import { blue, green, grey, orange, red } from "@mui/material/colors";
import { Components } from "@mui/material/styles";
import type { Theme } from "../types";
import { aquamarine } from "../colors";

export const MuiChip = {
  styleOverrides: {
    root: {
      borderRadius: "8px",
      height: "28px",
      "& .MuiChip-label": {
        paddingLeft: "7px",
        paddingRight: "7px",
      },
      "& .MuiChip-avatar": {
        marginRight: "-2px",
      },
    },
  },
  variants: [
    {
      props: {
        color: "primary",
      },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { color: aquamarine[100], borderColor: theme.palette.primary.main, border: "1px solid" }
          : {
              color: aquamarine[900],
              borderColor: theme.palette.primary.main,
              border: "1px solid",
            },
    },
    {
      props: { color: "primary", variant: "filled" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { backgroundColor: aquamarine[900] }
          : { backgroundColor: aquamarine[50] },
    },
    {
      props: { color: "success" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { color: green[100], borderColor: green[100], border: "1px solid" }
          : { color: green[900], borderColor: green[900], border: "1px solid" },
    },
    {
      props: { color: "success", variant: "filled" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { backgroundColor: green[900] }
          : { backgroundColor: green[50] },
    },
    {
      props: { color: "info" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { color: blue[100], borderColor: blue[100], border: "1px solid" }
          : { color: blue[900], borderColor: blue[900], border: "1px solid" },
    },
    {
      props: { color: "info", variant: "filled" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { backgroundColor: blue[900] }
          : { backgroundColor: blue[50] },
    },
    {
      props: { color: "warning" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { color: orange[100], borderColor: orange[100], border: "1px solid" }
          : { color: orange[900], borderColor: orange[900], border: "1px solid" },
    },
    {
      props: { color: "warning", variant: "filled" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { backgroundColor: orange[900] }
          : { backgroundColor: orange[50] },
    },
    {
      props: { color: "error" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { color: red[100], borderColor: red[100], border: "1px solid" }
          : { color: red[900], borderColor: red[900], border: "1px solid" },
    },
    {
      props: { color: "error", variant: "filled" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { backgroundColor: red[900] }
          : { backgroundColor: red[50] },
    },
    {
      props: { color: "secondary" },
      style: ({ theme }) =>
        theme.palette.mode === "dark"
          ? { color: grey[100], borderColor: grey[100], border: "1px solid" }
          : { color: grey[900], borderColor: grey[900], border: "1px solid" },
    },
    {
      props: { color: "secondary", variant: "filled" },
      style: ({ theme }) => ({ backgroundColor: theme.palette.action.selected }),
    },
  ],
} satisfies Components<Theme>["MuiChip"];
